import { computed } from 'vue'
import { useJwt } from '@vueuse/integrations/useJwt'
import { useLocalStorage } from '@vueuse/core'
import { LOCAL_STORAGE_KEYS } from '~/constants'
import type { UserClaims } from '~/types/gql/generated/graphql'

type DecodedToken = ReturnType<typeof useJwt<UserClaims & { iat: number, exp: number }>>
/**
 * Composable only meant to be use when needed before store initialization
 * Example the authorization middleware which run before pinia store initialization
 */
export function useSession() {
  const token = useLocalStorage<string | null>(LOCAL_STORAGE_KEYS.TOKEN, null)

  const decodedToken = computed<DecodedToken | null>(() => {
    if (!token.value)
      return null
    return useJwt(token.value)
  })

  function setToken(newToken: string | null) {
    token.value = newToken
  }

  return {
    setToken,
    token,
    decodedToken,
  }
}
